import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { StockItemsImage } from "../../../../assets/images";
import {
  GetAllStockItemListPayloadType,
  GetSingleStockItemListPayloadType,
} from "../../../../commonTypes/clientSettingsTypes";
import StockItemListTable from "../../../../components/ClientSettings/StockManager/StockItems/StockItemTable/StockItemListTable";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../../components/commons";
import { STOCK_ITEM_HEADER } from "../../../../constant/tableHeadersConstants/clientSettingsconstants/stockItemHeader";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import { resetSession } from "../../../../redux/auth";
import {
  getAllStockItemListAction,
  getSingleStockItemDataAction,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetSingleStockItemData,
  resetStockItemList,
  resetStockItemListTotal,
} from "../../../../redux/clientSettings";
import { StockItemDetailsType } from "../../../../redux/clientSettings/clientSettingTypes";
import { RootState } from "../../../../redux/rootReducers";
import { SearchIcon } from "../../../../components/Icon";
import { Link } from "react-router-dom";

type AppProps = {
  history?: any;
  fetching: boolean;
  success: number | null;
  token: string | null;
  error: string | null;
  statusCode: number | null;
  totalCount: number;
  allStockItemList?: [] | any[];
  singleStockItemData: StockItemDetailsType[];
  dispatchResetClientSettingsError: () => void;
  dispatchResetClientSettingsSuccessAction: () => void;
  dispatchResetSingleStockData: () => void;
  dispatchResetSession: () => void;
  dispatchResetStockItemListTotal: () => void;
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) => void;
  dispatchGetSingleItemDataAction: (
    data: GetSingleStockItemListPayloadType
  ) => void;
  dispatchResetStockItemList: () => void;
};

const StockItemsList = ({
  history,
  token,
  success,
  fetching,
  error,
  statusCode,
  allStockItemList,
  totalCount,
  singleStockItemData,
  dispatchResetSingleStockData,
  dispatchResetClientSettingsError,
  dispatchResetClientSettingsSuccessAction,
  dispatchGetSingleItemDataAction,
  dispatchGetAllStockItem,
  dispatchResetSession,
  dispatchResetStockItemListTotal,
  dispatchResetStockItemList,
}: AppProps) => {
  const persistSearchTerm = history?.location?.state?.searchData;
  const [successMessage, setSuccessMessage] = useState<string>("");
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const [searchData, setSearchData] = useState(persistSearchTerm);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(20);
      const [data, setData] = useState<any[] | []>([]);
  

  //====================User Management=============================
  const [isAddStockItemPresent, setIsAddStockItemPresent] = useMenuCheck();
  const [isEditStockItemPresent, setIsEditStockItemPresent] = useMenuCheck();
  const [isBulkUploadStockItemPresent, setIsBulkUploadStockItemPresent] =
    useMenuCheck();

  //=================================================================

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleEditStockItemDetails = (id: any) => {
    dispatchResetSingleStockData();
    dispatchGetSingleItemDataAction({ token, client_code, stock_item_id: id });

    history?.push({
      pathname: `/client-settings/stock-manager/stock-items-list/edit-stock-item/${client_code}`,
      state: { client_code, company_name, searchData },
    });
  };
  useEffect(() => {
    setIsBulkUploadStockItemPresent("Bulk Upload Stock Item", "menu");
    dispatchResetSingleStockData();
    dispatchResetStockItemListTotal();
    dispatchResetStockItemList();
    setIsAddStockItemPresent("Add Stock Item", "menu");
    setIsEditStockItemPresent("Edit Stock Item", "menu");
    if (client_code && token) {
      let finalData = {
        limit,
        offset,
        token,
        client_code,
        search_term: searchData,
      };
      if(totalCount) {
        if (offset < totalCount) {
          dispatchGetAllStockItem(finalData);
      } 
    }else {
        dispatchGetAllStockItem(finalData);
      }
    }
    //eslint-disable-next-line
  }, []);

    useEffect(() => {
      if (allStockItemList?.length === 0) {
        setData(allStockItemList);
      }
      if (offset > 0) {
        setData((prv: any) => (allStockItemList && allStockItemList?.length>0) ?  [...prv, ...allStockItemList] : [...prv]);
      } else {
        setData((allStockItemList && allStockItemList?.length>0) ? allStockItemList : []);
      }
    }, [allStockItemList]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        fetchNewData();
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    //eslint-disable-next-line
  }, [searchData]);

    useEffect(() => {
      if (token) {
        let finalData = {
          limit,
          offset,
          token,
          client_code,
          search_term: searchData,
        };
        if (totalCount) {
          if (offset < totalCount) {
            dispatchGetAllStockItem(finalData);
          }
        } else {
          dispatchGetAllStockItem(finalData);
        }
      }
    }, [offset]);
  

  const fetchNewData = () => {
    if (token && client_code) {
      let finalData = {
        limit,
        offset,
        token,
        client_code,
        search_term: searchData,
      };
      if (offset === 0) {
      dispatchGetAllStockItem(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleRedirectToBulkUpload=()=>{
    history.push({
      pathname:`/client-settings/stock-manager/stock-items-list/bulk-upload/${client_code}`,
      state:{
        client_code,company_name
      }
    })
  }

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if (value?.length === 0) {
      let finalData = {
        token,
        client_code,
        limit,
        offset,
      };
      dispatchGetAllStockItem(finalData);
    }
  };
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (allStockItemList && allStockItemList?.length > 0) {
          if (!fetching && offset < totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };
    useEffect(() => {
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }, [allStockItemList]);
  

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      dispatchResetClientSettingsSuccessAction();
      toast.success(successMessage, {
        duration: 2000,
      });

      if (token && client_code) {
        let finalData = {
          token,
          client_code,
          search_term: searchData,
          limit,
          offset: 0,
        };
        if (offset === 0) {
          dispatchGetAllStockItem(finalData);
        } else {
          setOffset(0);
        }
      }
    }

    return false;
  };
  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader
          title="Stock Items"
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="col-md-6 text-right">
        {data?.length && isAddStockItemPresent ? (
          <button
            className="btn btn-primary"
            onClick={() =>
              history?.push({
                pathname: `/client-settings/stock-manager/stock-items-list/add-stock-item/${client_code}`,
                state: { client_code, company_name },
              })
            }
          >
            + Add Stock Item
          </button>
        ) : null}
      </div>
      <div className="col-md-12 mt-4">
        <div className="row mt-4">
          <div className="col-md-12">
            <div className="new-table-card">
              <div className="header">
                <div className="left-header">
                  <div className="heading">Stock Item List</div>
                  {!fetching && (
                    <div
                      className="sub-heading"
                      style={{ marginTop: "-22px" }}
                    >{`Total ${
                      totalCount ? totalCount : 0
                    } entries found`}</div>
                  )}
                </div>

                <div className="d-flex flex-row justify-content-end">
                  {isBulkUploadStockItemPresent && (
                    <div onClick={handleRedirectToBulkUpload}
                    className="btn btn-outline mr-2"
                style={{
                  width: "150px",
                  height: "38px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                    >
                      
                        <i className="fas fa-file-upload"></i>
                        &nbsp;Bulk&nbsp;Upload
                    </div>
                  )}
                  <div
                    className={
                      isBulkUploadStockItemPresent
                        ? "col-md-8 right-header"
                        : "col-md-10 right-header"
                    }
                  >
                    <span
                      style={{ position: "absolute", top: "8px", left: "25px" }}
                    >
                      <SearchIcon />
                    </span>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search"
                      onChange={(e) => handleSearch(e)}
                      style={{ paddingLeft: "35px" }}
                      value={searchData}
                    />
                  </div>
                </div>
              </div>
              {fetching && offset == 0? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : data?.length ? (
                <StockItemListTable
                  offset={offset}
                  company_name={company_name}
                  client_code={client_code}
                  fetching={fetching}
                  data={data}
                  headers={STOCK_ITEM_HEADER}
                  handleEditStockItemDetails={handleEditStockItemDetails}
                  isEditStockItemPresent={isEditStockItemPresent}
                />
              ) : (
                <EmptyListPage
                  title="No Stock Items Found!"
                  text="Add a stock item to see it here in the list!"
                  image={StockItemsImage}
                  imageWidth="30%"
                  showAddButton
                  buttonTitle="+ Add Stock Item"
                  onButtonClick={() =>
                    history?.push({
                      pathname: `/client-settings/stock-manager/stock-items-list/add-stock-item/${client_code}`,
                      state: { client_code, company_name },
                    })
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientSettings.fetching,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  success: state.clientSettings.success,
  allStockItemList: state.clientSettings.allStockItemList,
  totalCount: state.clientSettings.stockItemListTotal,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingsSuccessAction: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchGetSingleItemDataAction: (data: GetSingleStockItemListPayloadType) =>
    dispatch(getSingleStockItemDataAction(data)),
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) =>
    dispatch(getAllStockItemListAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetStockItemListTotal: () => dispatch(resetStockItemListTotal()),
  dispatchResetStockItemList: () => dispatch(resetStockItemList()),
  dispatchResetSingleStockData: () => dispatch(resetSingleStockItemData()),
});
export default connect(mapStateTopProps, mapDispatchToProps)(StockItemsList);
